import axios from "../../../js/project-axios.js";

const get = (appId, config) => {
    config = Object.assign({
        params: {
            appId
        }
    }, config);
    return axios.get("/appUser/app/get", config);
};

export default {
    get
};